import React from 'react';
import PropTypes from 'prop-types';
import GenericAlert from '../../../commons/GenericAlert';
import ImporterUpload from './Upload';
import useStyles from './styles';
import Violations from './Violations';

export default function Importer({ importer }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.importersGroup}>
        <ImporterUpload destination="products" id="productsImporter" />
        <ImporterUpload destination="associations" id="associationsImporter" />
      </div>
      {importer?.isLoading && <GenericAlert alertText="File is loading" type="warning" />}
      {importer?.response?.fileUploaded === 200 && <GenericAlert alertText="File uploaded" type="success" />}
      <Violations />
    </>
  );
}

Importer.propTypes = {
  importer: PropTypes.shape({
    response: PropTypes.objectOf(PropTypes.any),
    isLoading: PropTypes.bool,
  }).isRequired,
};
